import React, { useEffect, useState } from 'react';
import { rlsBypassQuery } from '../api/rlsBypassQuery';
import '../style.css';

function ReportList() {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAll, setShowAll] = useState(false);
  const [expandedId, setExpandedId] = useState(null);

  useEffect(() => {
    async function fetchReports() {
      try {
        const data = await rlsBypassQuery({
          table: 'customer_model_reports',
          select: '*',
          orderBy: { column: 'id', ascending: false },
          limit: 5,
        });
        setReports(data);
      } catch (error) {
        console.error('Error fetching reports:', error.message);
        setReports([]);
      } finally {
        setLoading(false);
      }
    }

    fetchReports();
  }, []);

  // Toggle to expand or collapse the row
  const handleToggleExpand = (id) => {
    setExpandedId(prev => (prev === id ? null : id)); // Collapse if already expanded
  };
const handleBuyNow = (item) => {
  console.log("handleBuyNow called with item:", item); 
  const orderWindow = window.open('https://www.mdlreports.com.au/new-order', '_blank');

  const messageData = {
    type: 'MRE_SELECTED',
    mreId: item.mr_approval,
    mreDetails: {
      mreId: item.mr_approval,
      startDate: item.start_date,
      endDate: item.end_date,
      make: item.make,
      model: item.model,
      chassisCode:item.chassis_code,
       mrApproval: item.mr_approval,
    },
   
  };
  let attempt=0;
  const maxattempt=20;
   const timer = setInterval(() => {
    if (orderWindow && !orderWindow.closed) {
      try {
        orderWindow.postMessage(messageData, 'https://www.mdlreports.com.au');
       // console.log("Message sent to new order window.");
        clearInterval(timer); //sent successfully
      } catch (err) {
       // console.warn("Retrying to send message...");
      }
    } else {
      clearInterval(timer); // window closed
    }

    if (++attempt >= maxattempt) {
      //console.error("Could not send message.");
      clearInterval(timer);
    }
  }, 500);
};

  /*const timer = setInterval(() => {
    if (orderWindow && orderWindow.postMessage) {
      orderWindow.postMessage(messageData, 'https://www.mdlreports.com.au'); // safer than '*'
      clearInterval(timer);
    }
  }, 500);
};*/
  

  return (
    <div className="container-fluid shadow -lg p-5 mb-5">
    
    <h1 className="text-center fw-bold heading-title scroll-target">Latest Approved Reports</h1>
    <p className='text-dark mb-4 text-center'>Stay updated with our newest additions</p>
      {loading ? (
        <p>Loading...</p>
      ) : reports.length === 0 ? (
        <p>No reports found.</p>
      ) : (
                <>
                  <div
                    style={{
                      maxHeight: showAll ? '300px' : 'auto',
                      overflowY: showAll ? 'auto' : 'visible',
                    }}
                  >
                    <div className="table-responsive " style={{ borderTop: "1px solid #101110ff", paddingTop: "12px" }}>
                      <table className="table table-hover transparent-table">
                        <thead >
                          <tr>
                            <th>S/N</th>
                            <th>Make</th>
                            <th>Model</th>
                            <th>Chassis Code</th>
                            <th>Body Type</th>
                            <th>Sevs Entry</th>
                            <th>MRE Approval</th>
                            
                            
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {reports.map((item, index) => (
                            <React.Fragment key={item.id}>
                              <tr>
                                <td data-label="S/N">{index + 1}</td>
                                <td data-label="Make">{item.make}</td>
                                <td data-label="Model">{item.model}</td>
                                <td data-label="Chassis Code">{item.chassis_code}</td>
                                <td data-label="Body Type">{item.body_type}</td>
                                  <td data-label="Sevs Entry">{item.sevs_entry}</td>
                                <td data-label="MRE Approval">{item.mr_approval}</td>
                                
                               
                              
                                  <td className="text-center">
                                  <span
                                    style={{ cursor: 'pointer', fontSize: '18px' }}
                                    onClick={() => handleToggleExpand(item.id)}
                                  >
                                    {expandedId === item.id ? <i className="bi bi-chevron-up"></i>  // 👆 Icon when EXPANDED
        : <i className="bi bi-chevron-down"></i> 
    }
                                  </span>
                                </td>
                                
                              </tr>
      
                              {/* Display additional fields when the row is expanded */}
                              {expandedId === item.id && (
                                <tr>
                                  <td colSpan="7">
                                {/* Expanded details */}
                                <div className="row custom-colour">
                                  
                                  <div className="col-md-3">
                                    <strong> Engine Details</strong>
                                   <p>Option 1 <strong>:</strong>&nbsp;{item.engine_option_1}</p>
                                   {item.engine_option_2&&item.engine_option_2?.trim()!=='-' && (
                                       <p>Option 2 <strong>:</strong>&nbsp;{item.customer_model_reports?.item.engine_option_2}</p>
                                     )}
                                  </div>
                                  <div className="col-md-3">
                                    <strong>Transmission & Drivetrain</strong>
                                    <p>Transmission <strong>:</strong>&nbsp;{item.transmission}<br/>
                                    Drivetrain <strong>:</strong>&nbsp;{item.drivetrain}</p>
                                    
                                  </div>
                                  <div className="col-md-3">
                                    <strong>Seat Details</strong>
                                    <p>Option 1 <strong>:</strong>&nbsp;{item.seats_option_1}<br/>
                                    {item.seats_option_2&&item.seats_option_2?.trim()!=='-' && (
                                       <p>Option 2 <strong>:</strong>&nbsp;{item.seats_option_2}</p>
                                     )}
                                     {item.seats_option_3&&item.seats_option_3?.trim()!=='-' && (
                                       <p>Option 3 <strong>:</strong>&nbsp;{item.seats_option_3}</p>
                                     )}
                                     </p>
                                  </div>
                                  
                                  <div className="col-md-3">
                                    <strong>Dates</strong>
                                    <p>Start <strong>:</strong>&nbsp;{item.start_date}<br/>
                                    End <strong>:</strong>&nbsp;{item.end_date}</p>
                                    </div>
                                   <div className="col-md-3">
                                    <strong>Reference </strong>
                                    <p>WI Ref <strong>:</strong>&nbsp;{item.mr_wi_reference}<br/>
                                    VC Ref <strong>:</strong>&nbsp;{item.mr_vc_reference}</p>
                                  
                                  </div>
                                   <div className="col-md-3">
                                    <strong>SEVS details</strong>
                                  
                                    <p>Sevs expiry <strong>:</strong>&nbsp;{item.sevs_expiry}</p>
                                    
                                  </div>
                                  <div className="col-md-3">
                                    <strong>Requirement</strong>
                                    <p>Origin <strong>:</strong>&nbsp;{item.origin_requirements}<br/>
                                    Body type <strong>:</strong>&nbsp;{item.body_type}<br/>
                                    Cats or km required <strong>:</strong>&nbsp;{item.cats_or_km_required}<br/>
                                    Camper conversion <strong>:</strong>&nbsp;{item.camper_conversion_required}<br/>
                                    Welcab type <strong>:</strong>&nbsp;{item.welcab_type}<br/>
                                    </p>
                                  </div>
                                  
                                  <div className="col-md-3">
                                 {item.mr_variation_description&&item.mr_variation_description?.trim()!=='' && (
                                    <div>
                                      <strong>Variation Description</strong>
                                      <p> <strong></strong>&nbsp;{item.mr_variation_description}</p>
                                       
                                     </div>
                                  )}
                                </div>
                                  
                                </div>
                              
                                      
                                      
                                    
                                  </td>

                                  <td colSpan="1 ">
                                
                                <div className="d-flex justify-content-end">
                                 
                                   <button className="btn btn-danger" onClick={() => handleBuyNow(item)} >
                                         Buy Now
                                  </button>
                                   </div>
                              
                              </td>
                                </tr>
                              )}
                            </React.Fragment>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
      
                  
                </>
              )}
            </div>
          
        );
      };

export default ReportList;
